
// VEHICLE SELECTORS
export const vehicleTheme = (provided: any) => ({
  ...provided,
  borderRadius: 0,
});
export const getVehicleStyle = (smallSelector?: boolean, screen1440?: boolean) => {
  return {
    control: (provided: any) => ({
      ...provided,
      cursor: 'pointer',
      height: screen1440 ? 49 : 59.5,
      minHeight: screen1440 ? 49 : 59.5,
      fontSize: screen1440 ? 15 : 18,
      fontWeight: 300,
      padding: smallSelector ? '0 10px 0 18px' : screen1440 ? '0 9px' :  '0 11px',
      outline: 'none',
      border: 'none',
      boxShadow: 'none',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      fontWeight: 300
    }),
    input: (provided: any) => ({
      ...provided,
      color: '#1A1C1F',
      fontWeight: 300,
    }),
    indicatorSeparator: () => ({ display: "none", }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      color: '#1A1C1F',
      width: 18,
      padding: 0, 
    }),
    menu: (provided: any) => ({
      ...provided,
      borderRadius: 2,
      maxHeight: '44vh',
      zIndex: 5000
    }),
    menuList: (provided: any) => ({
      ...provided,
      maxHeight: '44vh',
      zIndex: 5000
    }),
    option: (provided: any, { isFocused, isSelected }: any) => ({
      ...provided,
      border: 'none',
      cursor: 'pointer',
      display: "flex",
      justifyContent: "space-between",
      padding: "12px 14px",
      fontSize: screen1440 ? 15 : 18,
      minHeight: 42,
      height: 'fit-content',
      color: '#1A1C1F',
      overflow: 'hidden',
      fontWeight: 300,
      backgroundColor: isSelected ? '#E6F2FF' : isFocused ? '#f5f5f5' : 'white'
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: '#1A1C1F',
    })
  };
}
// END OF VEHICLE SELECTORS
